import React from 'react';
import injectSheet from 'react-jss';
import styleSheet from './styles';
import classNames from 'classnames';

interface PersonalizationToggleProps {
  classes: any;
  pills: any;
  label: string;
  activePills: {};
  showPersonalizationPills: boolean;
  displayHeaderCartoonBoolean: boolean;
  onClick: (pill: any) => void;
  onCaretClick?: (input: any) => void;
  personalizationCompleted: boolean;
}

type pillData = {
  value: string;
  label: string;
  group: string;
};

const PersonalizationToggle = ({
  classes,
  pills,
  label,
  activePills,
  displayHeaderCartoonBoolean,
  onClick,
  showPersonalizationPills,
  onCaretClick,
  personalizationCompleted,
}: PersonalizationToggleProps) => {
  const groups = pills.map((pill: pillData) => pill.group);
  const uniqueGroupsList = [...new Set(groups)];

  const pillContainerClass = displayHeaderCartoonBoolean
    ? classes.showPillContainer
    : classes.noHeaderContainer;

  return (
    <div
      className={classNames(
        classes.togglePillContainer,
        showPersonalizationPills
          ? pillContainerClass
          : classes.hidePillContainer
      )}
    >
      <label className={classes.toggleLabel}>
        {showPersonalizationPills ? 'ENTER ANSWER ABOVE INSTEAD' : label}
        <button 
          style={{ background: 'none', border: 'none' }}
          onClick={!personalizationCompleted && onCaretClick}
        >
          <img
            style={{
              transform: showPersonalizationPills ? 'rotate(180deg)' : '',
              cursor: personalizationCompleted ? 'not-allowed' : 'pointer',
            }}
            className={classes.icon}
            src="images/UI/caret.svg"
        />
        </button>
      </label>
      <div className={showPersonalizationPills ? classes.toggleContainer : classes.hideToggle}>
        {uniqueGroupsList.sort().map((group: string) => {
          return (
            <>
              <label className={classes.groupLabel}>{group}</label>
              <div
                className={classes.pillContainer}
                style={{ margin: '15px 0' }}
                tabIndex={0}
                aria-label="Or Let Me Choose"
              >
                {pills.map((pill: pillData) =>
                  pill.group === group ? (
                    <button
                      className={classNames(
                        classes.pill,
                        activePills[pill.value] && classes.activePill
                      )}
                      value={pill.value}
                      onClick={() => onClick(pill.value)}
                      key={pill.value}
                    >
                      {pill.label}
                    </button>
                  ) : null
                )}
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};

export default injectSheet(styleSheet)(PersonalizationToggle);
